import { useState, useCallback } from 'react';

export default function useSimpleInput(defaultValue = '') {
  const [value, setValue] = useState(defaultValue);

  const onSetValue = useCallback(({ target }) => setValue(target.value), []);

  return [value, onSetValue];
}
